module.exports = __webpack_public_path__ + "static/media/teamMemberIconInactive.0bf7de22.svg";